import { lazyLoad } from 'app/utils/loadable';

export const RepairCompletePage = lazyLoad(
  () => import('./repair-complete-page'),
  (module) => module.RepairCompletePage
);
